import React from 'react';

export default class OrderBuilderNavigation extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="steps">
          <ul className="nav nav-wizard">
            <li className={this.props.active_tab == 'products' ? 'active products-nav' : 'products-nav'}><p data-step={'products'}>{I18n.t('products')}</p></li>         
            <li className={this.props.active_tab == 'payment' ? 'active payment-nav' : 'payment-nav'}><p data-step={'payment'}>{I18n.t('payment')}</p></li>
          </ul>
        </div>
      </div>
    );
  };
};
